import { ChangeDetectionStrategy, Component, effect, inject, input, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { BaasAppState, generateRandomNumber } from '@lvflanders/bar';

import { BaasGlobalFooter } from '../baas-global-footer';
import { BaasGlobalHeader } from '../baas-global-header';

@Component({
    selector: 'baas-unavailable-layout',
    templateUrl: './baas-unavailable-layout.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasGlobalFooter, BaasGlobalHeader]
})
export class BaasUnavailableLayout implements OnInit {
    readonly #state = inject(BaasAppState);

    readonly title = input.required<string>();
    readonly content = input<SafeHtml | string>();
    readonly showGlobalHeaderFooter = input(false);

    protected imagePath: string;
    protected hiResImagePath: string;

    constructor() {
        effect(() => (document.title = this.title() || this.#state.toepassing.naam));
    }

    ngOnInit(): void {
        const randomNumber = generateRandomNumber(1, 8);
        this.imagePath = `${this.#state.location.baasStatic.url}images/all/lv-melding-circle-0${randomNumber}.png`;
        this.hiResImagePath = `${this.#state.location.baasStatic.url}images/all/lv-melding-circle-0${randomNumber}@2x.png`;
    }
}
